<template>
  <div class="page chat-page">
    <div id="outputScreen">
      <p class="privacy-note">{{ appVocubulary.privacyNote }}</p>
      <w-message
        v-for="message in messages"
        :key="message.text"
        :replyText="message.replyText"
        :byWho="message.byWho"
        :text="message.text"
        @set-replytext="setReplyText"
      />
    </div>
    <w-input
      @send-content="sendMessage()"
      :reply="replyText"
      @no-reply="replyText = ''"
    >
      <textarea
        id="chat-textarea"
        v-model="typedMessage"
        @input="adjustDirection($event)"
      ></textarea>
    </w-input>
    <transition name="opacity">
      <w-popup ref="popup" />
    </transition>
  </div>
</template>

<script>
import WInput from "../components/WInput.vue";
import WPopup from "../components/WPopup.vue";
import WMessage from "../components/WMessage.vue";

export default {
  name: "Chat",
  data() {
    return {
      typedMessage: "",
      replyText: "",
      resolvePromise: "",
      rejectPromise: "",
      messages: [],
    };
  },
  components: { WPopup, WInput, WMessage },
  computed: {
    socket() {
      return this.$store.state.socket;
    },
    thisUser() {
      return this.$store.state.user;
    },
    thePartner() {
      return this.$store.state.partner;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Chat;
    },
  },
  methods: {
    sendMessage() {
      // check if the input field is empty :
      if (this.typedMessage.trim() === "") return;

      // send the message to the server :
      this.socket.emit("messageFromClient", {
        id: this.thisUser._id,
        name: this.thisUser.name,
        room: this.thisUser.room,
        text: this.typedMessage,
        replyText: this.replyText,
      });

      // append the message to the screen :
      this.messages.push({
        text: this.typedMessage,
        byWho: "me",
        replyText: this.replyText,
      });

      // reset the text and focus after sending :
      this.typedMessage = "";
      this.replyText = "";

      document
        .getElementById("outputScreen")
        .scrollBy(
          0,
          document.getElementById("outputScreen").scrollHeight + 800
        );

      document.querySelector("textarea").focus();
    },

    setReplyText(newText) {
      this.replyText = newText;
    },

    adjustDirection(e) {
      let ar = /[\u0621-\u064A]/;
      if (ar.test(e.currentTarget.value[0])) {
        e.currentTarget.dir = "rtl";
      } else {
        e.currentTarget.dir = "ltr";
      }
    },

    async showPopup(options, next) {
      const confirmationResult = await this.$refs.popup.show(options);
      if (confirmationResult) {
        next();
      } else {
        next(false);
      }
    },
  },
  beforeMount() {
    if (
      (this.thisUser.room_name !== "" && this.thisUser.room === "") ||
      this.thisUser.name === this.thePartner.name
    ) {
      document.getElementById("home-link").click();
    }
  },
  mounted() {
    // append messages coming from server :
    this.socket.on("messageFromServer", (data) => {
      this.messages.push({
        text: data.text,
        byWho: data.name,
        replyText: data.replyText,
      });
    });

    // remove the partner object from store when he leaves the chat :
    this.socket.on("removePartner", (partnerId) => {
      if (this.thePartner.socketId === partnerId) {
        this.partnerLeft = true;
        document.getElementById("home-link").click();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (!this.partnerLeft) {
      this.showPopup(
        {
          message: this.appVocubulary.confirmLeave,
          confirmText: "OK",
          cancelText: "CANCEL",
        },
        next
      );
    } else {
      this.showPopup(
        {
          message: `${this.thePartner.name} ${this.appVocubulary.userLeft}`,
          confirmText: "OK",
        },
        next
      );
    }
  },
  beforeUnmount() {
    this.socket.emit("leaveRoom", {
      roomId: this.thisUser.room,
      isPartner: true,
    });
  },
  unmounted() {
    this.socket.removeAllListeners("messageFromServer");
    this.socket.removeAllListeners("removePartner");
  },
};
</script>

<style lang="scss">
.chat-page {
  padding: 0 !important;
  overflow: hidden;
}
header {
  span {
    color: grey;
  }
}
#outputScreen {
  direction: ltr;
  height: calc(100% - 90px);
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px;

  & > p {
    color: grey;
    width: fit-content !important;
    font-size: 0.8em;
    background-color: rgba(128, 128, 128, 0.2);
    padding: 8px 16px;
    border-radius: 40px;
    margin: 16px auto 30px !important;
  }
}
</style>
